export default __webpack_public_path__ + "static/media/OrangeCirclePaywall.9d9dda16.svg";